export const AI_AGENTS = {
  AI_SCHEDULING: "AI Scheduling",
  AI_COST_ANALYSIS: "AI Cost Analysis",
  AI_FRONTDESK:"AI FrontDesk",
  AI_ANALYTICAL: "AI Analytical",
};

export const CALENDAR_ROLES = {
    OWNER: 'OWNER',
    EDITOR : 'EDITOR',
    VIEWER : 'VIEWER'
};

export const CALENDAR_TYPES = {
    DSS: 'DSS',
    OD : 'OD',
    GOOGLE : 'GOOGLE'
};


// Types of lazy loadings

export const GET_CONVERSATIONS = {
  LESSTHAN : "lt",
  GREATERTHAN : "gt",
  LESSTHAN_EQUAL : "lte" // using for search
};


export const EVENT_STATUS = {
  SCHEDULED : "SCHEDULED",
  CANCELLED : "CANCELLED",
  POSTPONED : "POSTPONED",
  COMPLETED : "COMPLETED"
};

export const CONTACT_IMPORT_STATUS = {
  SUCCESS : "SUCCESS",
  FAILED : "FAILED",
  ROLLBACK : "ROLLBACK"
};

export const WORKFLOW_STATUS = {
  ACTIVE : "active",
  DRAFT : "draft",
  ARCHIVED : "archived"
};

